var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSquareRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#B22E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7402 16.28C10.5502 16.28 10.3602 16.21 10.2102 16.06C9.92018 15.77 9.92018 15.29 10.2102 15L13.2102 12L10.2102 9C9.92018 8.71 9.92018 8.23 10.2102 7.94C10.5002 7.65 10.9802 7.65 11.2702 7.94L14.8002 11.47C15.0902 11.76 15.0902 12.24 14.8002 12.53L11.2702 16.06C11.1202 16.21 10.9302 16.28 10.7402 16.28Z",
    fill: "#B22E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareRight);
export default __webpack_public_path__ + "static/media/arrow-square-right.58db606c22342e44b497c93a685e13b2.svg";
export { ForwardRef as ReactComponent };